import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";

const Privacy = () => {
  const [searchParams] = useSearchParams();
  const isModule = searchParams.get("app");

  return (
    <>
      {isModule === "true" ? [] : <HeaderLayout />}
      <div>
        <div
          style={{
            padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2 align="center">Privacy Policy</h2>

          <p>
            At <strong>Bonoxi</strong>, accessible from{" "}
            <a
              href="https://www.bonoxi.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.bonoxi.com
            </a>
            , we are committed to protecting your privacy. This Privacy Policy
            explains what information we collect, how we use it, and your rights
            related to your data.
          </p>

          <h3>1. Information We Collect</h3>
          <ul>
            <li>
              <strong>Uploaded Files & Media:</strong> Documents (Word, Excel,
              PowerPoint, PDF) and images or photos you upload for conversion
              (e.g. Image to PDF, or PDF to Word/Excel/PowerPoint/Images), plus
              any logo or picture you attach to a QR code (Brand QR logo,
              Message QR picture, or a File QR attachment).
            </li>
            <li>
              <strong>QR Code & Document Content:</strong> Text, formatted rich
              text, links, and other details you provide to generate a QR code
              (Website, Text, Location, Brand, Social, File, vCard, Product, or
              Message) or a Text-to-PDF document.
            </li>
            <li>
              <strong>Account Information:</strong> Your name, email address,
              and authentication details when you sign up or log in, including
              via Google Sign-In.
            </li>
            <li>
              <strong>Device and Usage Data:</strong> IP address, browser type,
              operating system, and usage logs.
            </li>
            <li>
              <strong>Contact Information:</strong> Only if voluntarily provided
              through contact forms.
            </li>
          </ul>

          <h3>2. Media & File Access</h3>
          <p>
            We only access photos, images, documents, or other files that you
            actively choose to upload through your browser&apos;s file picker —
            for example, when using Image to PDF, adding a logo to a Brand QR
            code, attaching a picture to a Message QR code, or uploading a file
            for a File QR code.
          </p>
          <p>
            We do not access your camera, microphone, photo library, or any
            other device media unless you directly select a file to upload.
            Media you upload is used solely to complete the specific conversion
            or QR code you requested, and is handled according to the File and
            Data Security practices below.
          </p>

          <h3>3. How We Use Your Information</h3>
          <ul>
            <li>To process file and image conversions to and from PDF.</li>
            <li>
              To generate, store, and deliver QR codes, including
              password-protected QR codes.
            </li>
            <li>
              To maintain your account and your conversion/QR history in your
              dashboard.
            </li>
            <li>To improve website performance and functionality.</li>
            <li>
              To communicate with you regarding support or service updates (only
              if you initiate contact).
            </li>
          </ul>

          <h3>4. File and Data Security</h3>
          <ul>
            <li>
              Files and media uploaded for one-time conversions are
              automatically deleted after processing.
            </li>
            <li>
              QR codes, PDFs, and other content you generate while logged in are
              retained in your account until you delete them or request account
              deletion.
            </li>
            <li>
              We do not sell or share your uploaded files, QR content, or
              documents with third parties.
            </li>
            <li>All data transmission is secured with HTTPS encryption.</li>
          </ul>

          <h3>5. Third-Party Services</h3>
          <p>
            We may use third-party tools like analytics or hosting providers.
            These services may collect certain data to help us monitor and
            improve our platform. We ensure they comply with industry-standard
            privacy regulations.
          </p>

          <h3>6. Your Rights & Data Deletion Requests</h3>
          <p>You have the right to:</p>
          <ul>
            <li>
              Access, correct, or request a copy of the personal data we hold
              about you.
            </li>
            <li>
              Request deletion of any file, QR code, document, or account data
              you&apos;ve submitted.
            </li>
            <li>Opt out of any future communications.</li>
          </ul>

          <p>
            <strong>How to request data deletion:</strong>
          </p>
          <ol>
            <li>
              Email us at{" "}
              <a href="mailto:support@bonoxi.com">support@bonoxi.com</a> with
              the subject line <strong>&quot;Data Deletion Request&quot;</strong>.
            </li>
            <li>
              Include the email address linked to your Bonoxi account, and let
              us know whether you&apos;d like specific files or QR codes removed,
              or your entire account and all associated data deleted.
            </li>
            <li>
              We will verify your request and permanently delete the specified
              data within 30 days, except where we are required to retain it to
              comply with a legal obligation.
            </li>
          </ol>
          <p>
            You will receive a confirmation email once your data has been
            deleted. For any other privacy questions, contact us at:{" "}
            <a href="mailto:support@bonoxi.com">support@bonoxi.com</a>
          </p>

          <h3>7. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. The updated
            version will be posted on this page with the revised date.
          </p>
          <hr />
          <p>
            <strong>Effective Date:</strong> May 15, 2025
            <br />
            <strong>Last Updated:</strong> September 28, 2026
          </p>
        </div>
      </div>
      {isModule === "true" ? [] : <FooterLayout />}
    </>
  );
};

export default Privacy;
